import { render, staticRenderFns } from "./HealthAdvice.vue?vue&type=template&id=79ae43c0&scoped=true&"
import script from "./HealthAdvice.vue?vue&type=script&lang=js&"
export * from "./HealthAdvice.vue?vue&type=script&lang=js&"
import style0 from "./HealthAdvice.vue?vue&type=style&index=0&id=79ae43c0&lang=less&scoped=true&"
import style1 from "./HealthAdvice.vue?vue&type=style&index=1&id=79ae43c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae43c0",
  null
  
)

export default component.exports